import { Component, Input } from '@angular/core';
import { ReleaseEnvironment } from '../models/release-environment';
import { DeployPhase } from '../models/deploy-phase';
import { WorkflowTask } from '../models/workflow-task';
import { ServiceConnection } from '../models/service-connections';

@Component({
    selector: 'app-task-display',
    templateUrl: './task-display.component.html',
    styleUrls: ['./task-display.component.css'],
    standalone: false
})
export class TaskDisplayComponent {

  @Input() environments!: ReleaseEnvironment[];
  @Input() title!: string;
  @Input() serviceConnections!: ServiceConnection[];

  constructor() { }

  getEnvironmentStatusClass(env: ReleaseEnvironment): string {
    return this.getStatus(env.status, env.childStatus);
  }

  getDeployPhaseStatusClass(phase: DeployPhase): string {
    return this.getStatus(phase.status, phase.childStatus);
  }

  getWorkflowTaskStatusClass(wfTask: WorkflowTask): string {
    return this.getStatus(wfTask.status, wfTask.childStatus);
  }

  getStatus(status: string, childStatus: string) {
    let classString = childStatus === 'modified' ? 'turquoise-border ' : '';
    switch (status) {
      case 'added':
        classString += 'green';
        break;
      case 'deleted':
        classString += 'red';
        break;
      case 'edited':
        classString += 'blue';
        break;
      default:
        classString += 'gray';
        break;
    }
    return classString;
  }

  getPanelTitleClass(className: string, task?: WorkflowTask): string {
    let classString = className.includes('green') || className.includes('red') || className.includes('blue') ? 'white ' : '';
    classString += !task || task.enabled ? '' : 'disabled';
    return classString;
  }
}
